<template>
  <div>
    <el-button @click="downBtn">下载</el-button>
    <div
      id="test"
    >
<!--    <div-->
<!--      id="test"-->
<!--      :style="'background-image:url(' + img1 + ');background-repeat: no-repeat'"-->
<!--    >-->
      <p style="text-align: center; font-size: 20px">海报图</p>
      <!-- 这里重点：crossorigin="anonymous"这句话意思是允许跨域，因为有些图片可能会出现不同源不允许下载的情况，添加这个可以下载 -->
<!--      <img :src="img2" alt="" class="centerImg" crossorigin="anonymous" />-->
      <img :src="'https://duole.fznet.top/images/zhengjishejidan1.png'" alt="" class="centerImg" crossorigin="anonymous" />
    </div>
  </div>
</template>

<script>
import html2canvas from "html2canvas"; //引入组件  需要先下载 npm install html2canvas --save
export default {
  data() {
    return {
      form: "",
      formLabelWidth: "120px",

      posterImg: "", //base64图片地址
      img1: "", //图片1
      img2: "https://duole.fznet.top/images/zhengjishejidan1.png", //图片2

      //下面的是上传图片组件用到的
      ruleForm: {
        imgList: [],
        imgList2: [],
      },
      mapListed: [],
      mapListed2: [],
    };
  },
  methods: {
    //合成并下载图片
    downBtn() {
      //获取dom，这里合成图片是这个dom内的一切元素都会一起合成一个图片下载下来，包含里面的文字和图片，所以可以自行调整这个dom内的内容，包括文字和图片样式等，相当于就是把这个div的内容截图下来了
      let dom = document.getElementById("test");
      //调用方法下载
      html2canvas(dom, {
        useCORS: true, //这个为true代表允许跨域
        allowTaint: false,
        logging: false,
        letterRendering: true,
      }).then((canvas) => {
        this.posterImg = canvas.toDataURL("image/png"); //转base64
        let a = document.createElement("a"); // 生成一个a元素
        let event = new MouseEvent("click"); // 创建一个单击事件
        a.download = "photo"; // 设置图片名称
        a.href = this.posterImg; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      });
    },
  },
};
</script>

<style>
/* 设置盒子的大小，如果不设置，下载下来的截图会是按全屏大小来的，如果图片没有铺满，会把空白处一起下载下来。 */
#test {
  width: 400px;
  height: 600px;
}
/* 调整二维码图片的位置 */
.centerImg {
  width: 400px;
  height: 600px;
}
</style>
